import React from 'react';
import {Fragment} from 'react';
import styled from 'styled-components';

import CloseSvg from '../media/close.svg';

import {maxExtendedWidth, pxToEm} from './globalStyles';
import Modal from './modal';

//#region Styled Components

const StyledBoundComponentWrapperDiv = styled.div`
  display: inline-block;
  cursor: pointer;
`;

//#endregion

interface Props {
  boundComponent: React.ReactNode;
  showCloseIcon?: boolean;
}

interface State {
  isActive: boolean;
}

class BoundModal extends React.Component<Props, State> {
  public state: State = {
    isActive: false
  };

  private handleToggle = () => {
    this.setState(prevState => ({isActive: !prevState.isActive}));
  };

  public render() {
    return (
      <Fragment>
        <StyledBoundComponentWrapperDiv onClick={this.handleToggle}>
          {this.props.boundComponent}
        </StyledBoundComponentWrapperDiv>

        {this.state.isActive && this.renderModalPanel()}
      </Fragment>
    );
  }

  private renderModalPanel = () => {
    return (
      <Modal show={this.state.isActive} showCloseIcon={this.props.showCloseIcon} onClose={this.handleToggle}>
        {this.props.children}
      </Modal>
    );
  };
}

export default BoundModal;
